import { useRouter } from 'next/router'; // Return the current browse category slug

export var useCurrentBrowseCategorySlug = function useCurrentBrowseCategorySlug() {
  var _router$query;

  var router = useRouter();
  var maybeCategorySlug = router === null || router === void 0 ? void 0 : (_router$query = router.query) === null || _router$query === void 0 ? void 0 : _router$query.categorySlug;
  return Array.isArray(maybeCategorySlug) ? maybeCategorySlug[0] : maybeCategorySlug;
};